import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.CorteDiarioDTO;
type Column = kea.Grid2Column<Entity>;

/**Columnas fijas del grid */
const columnasFijas: Column[] = [
    { title: "Fecha desde", cell: x => ({ data: kea.toDate(x.FechaDesde) }) },
    { title: "Fecha hasta", cell: x => ({ data: kea.toDate(x.Fecha) }) },
    { title: "Sucursal", cell: x => ({ data: x.NombreSucursal }) },
];

export interface BotonesListaDeps {
    onImprimir: (x: Entity) => void;
}

/**Obtiene las columnas del grid */
export function columnas(deps: BotonesListaDeps): Column[] {
    const botones = kea.columnaBotones([
        { onClick: deps.onImprimir, tooltip: "imprimir matriz al corte", iconClass: fa("file-excel-o") }
    ]);
    return [botones, ...columnasFijas];
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cortediario/list/columns.tsx